import React from 'react';
import { PropTypes } from 'prop-types';

import './skiingWebcams.scss';
import LocationWebcams from 'components/locationWebcams/LocationWebcams';

function SkiingWebcams({ locationWebcams, htmlWebcams, translations }) {
  if (!locationWebcams) {
    // TODO: Return empty state?
    return null;
  }

  return (
    <div>
      <LocationWebcams
        webcams={locationWebcams}
        translations={translations}
        htmlWebcams={htmlWebcams}
      />
    </div>
  );
}

SkiingWebcams.propTypes = {
  translations: PropTypes.object,
  locationWebcams: PropTypes.arrayOf(PropTypes.object),
  htmlWebcams: PropTypes.arrayOf(PropTypes.string),
};

export default SkiingWebcams;
